import { render, staticRenderFns } from "./SelectedBookingView.vue?vue&type=template&id=2d962028"
import script from "./SelectedBookingView.vue?vue&type=script&lang=js"
export * from "./SelectedBookingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports